const windowPosition = () => {};

export const frenchDoorWindow = (p5, trait, width, yurtTrait, windowNumber) => {
  const testText = (string) => {
    p5.push();
    p5.fill("black");
    p5.text(string, 20, 20);
    p5.pop();
  };

  const { twoByW, frenchDoor, pixels, frenchHeader, frenchW } = trait;
  const { windowW, sill, windowH, placement } = trait[windowNumber];
  let xcenter = width / 2;
  const ycenter = yurtTrait.h / 2 + 5 * trait.pixels;
  const bottomOfWall = ycenter + yurtTrait.h / 2 + twoByW;
  const wallWidth = 48 * trait.pixels - twoByW * 2;

  const sillHeight = sill - twoByW;

  const frenchDoorPos = {
    h: 81.5 * pixels + frenchHeader + twoByW * 2,
    w: frenchW === "6ft" ? 16.5 * trait.pixels : 10.5 * trait.pixels,
  };

  const frenchDoorWallExcess = wallWidth - frenchDoorPos.w;

  const windowPos = {
    y: bottomOfWall - sill - windowH / 2,
    w: windowW + twoByW * 2,
    x: 0,
  };

  if (sillHeight < frenchDoorPos.h) {
    if (windowPos.w > frenchDoorWallExcess) {
      windowPos.w = frenchDoorWallExcess;
    }
    switch (frenchDoor) {
      case "left":
        xcenter = xcenter - frenchDoorPos.w;
        break;
      case "right":
        xcenter = xcenter + frenchDoorPos.w;
        break;
      default:
        break;
    }
  }

  const relativePos = (width, doorOrientation, windowOrientation) => {
    let position = 0;

    if (doorOrientation === "left") {
      switch (windowOrientation) {
        case 1:
          position = xcenter - wallWidth / 2 + width / 2;
          break;
        case 2:
          position = xcenter + wallWidth / 2 - width / 2 - frenchDoorPos.w;
          break;
        default:
          position = xcenter - frenchDoorPos.w / 2;
          break;
      }
    } else {
      switch (windowOrientation) {
        case 1:
          position = xcenter + wallWidth / 2 - width / 2;
          break;
        case 2:
          position = xcenter - wallWidth / 2 + width / 2 + frenchDoorPos.w;
          break;
        default:
          position = xcenter + frenchDoorPos.w / 2;
          break;
      }
    }

    return position;
  };

  const sillPos = {
    bottom: windowPos.y + windowH / 2 + twoByW / 2,
  };

  const lintelPos = {
    bottom: windowPos.y - windowH / 2,
    w: wallWidth,
    x: xcenter,
  };

  windowPos.x = relativePos(windowPos.w, frenchDoor, placement / pixels);

  const jacks = {
    left: {
      x: windowPos.x - windowPos.w / 2 + twoByW / 2,
      y: bottomOfWall - twoByW / 4 - twoByW / 2 - sillHeight / 2 - windowH / 2,
      h: sillHeight + windowH - twoByW / 2,
    },
    right: {
      x: windowPos.x + windowPos.w / 2 - twoByW / 2,
      y: bottomOfWall - twoByW / 4 - twoByW / 2 - sillHeight / 2 - windowH / 2,
      h: sillHeight + windowH - twoByW / 2,
    },
  };

  p5.push();
  p5.rectMode(p5.CENTER);
  // render window
  p5.fill("white");
  p5.rect(windowPos.x, windowPos.y, windowPos.w, windowH);

  //render sill
  p5.fill("lightgrey");
  p5.rect(windowPos.x, sillPos.bottom, windowPos.w, twoByW);

  //render lintel
  p5.rect(lintelPos.x, lintelPos.bottom, lintelPos.w, twoByW);

  // render jacks
  p5.rect(jacks.left.x, jacks.left.y, twoByW, jacks.left.h);
  p5.rect(jacks.right.x, jacks.right.y, twoByW, jacks.right.h);
  p5.pop();
};
